import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/configs/app.config';
import { AppComponent } from './app/app.component';
import { ModuleRegistry } from 'ag-grid-community';
import {
  AllCommunityModule,
  AllEnterpriseModule,
  LicenseManager,
} from 'ag-grid-enterprise';

ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);

LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-060751}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Viasema}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Andromeda}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Andromeda}_need_to_be_licensed___{Andromeda}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{7_August_2025}____[v3]_[01]_MTc1NDUyMTIwMDAwMA==5e8ba0135cc753bbb259a0b8d6974848'
);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
